module.exports = __webpack_public_path__ + "static/media/property-managers-4.f577199f.svg";